import { render, staticRenderFns } from "./AgencyPayments.vue?vue&type=template&id=3f151cf5&scoped=true&"
import script from "./AgencyPayments.vue?vue&type=script&lang=js&"
export * from "./AgencyPayments.vue?vue&type=script&lang=js&"
import style0 from "./AgencyPayments.vue?vue&type=style&index=0&id=3f151cf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f151cf5",
  null
  
)

export default component.exports